export default __webpack_public_path__ + "static/media/placeholder-large-h.2b89178f.png";